export default __webpack_public_path__ + "static/media/jcb.dae3a79b.svg";